import { render, staticRenderFns } from "./ActivityT.vue?vue&type=template&id=72ff8736&scoped=true&"
import script from "./ActivityT.vue?vue&type=script&lang=ts&"
export * from "./ActivityT.vue?vue&type=script&lang=ts&"
import style0 from "./ActivityT.vue?vue&type=style&index=0&id=72ff8736&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ff8736",
  null
  
)

export default component.exports